import { render } from "./DTAdministradores.vue?vue&type=template&id=c17abf06&scoped=true"
import script from "./DTAdministradores.vue?vue&type=script&lang=js"
export * from "./DTAdministradores.vue?vue&type=script&lang=js"

import "./DTAdministradores.vue?vue&type=style&index=0&id=c17abf06&scoped=true&lang=css"

import exportComponent from "/home/computacionucat/ucat-evaluacion-desempeno-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c17abf06"]])

export default __exports__